import { useEffect, useState } from 'react';
import { lerAvisosLidos, marcarAvisoLido } from '../../avisos-lidos';

/**
 * AVISO CRÍTICO — o do 1.0 (balconista.html, texto do dono). Só fecha depois de 8 s: é para LER.
 * UMA VEZ POR PESSOA (dono, 28/09): o "li" fica no servidor — lido num aparelho, não volta em
 * outro (antes ficava só no navegador e voltava em aparelho novo, aba anônima, Safari limpo).
 */

const ESPERA = 8;
const chaveDe = (login: string) => `inovapay2.aviso-critico.v1.${login}`;

export function jaLeu(login: string): boolean {
  try {
    return window.localStorage.getItem(chaveDe(login)) === '1';
  } catch {
    return true; // sem armazenamento, não prende a pessoa a cada abertura
  }
}

function guardarLocal(login: string) {
  try {
    window.localStorage.setItem(chaveDe(login), '1');
  } catch {
    // segue
  }
}

export function AvisoCritico({ login }: { login: string | null }) {
  const [aberto, setAberto] = useState(false);
  const [falta, setFalta] = useState(ESPERA);

  useEffect(() => {
    if (!login) return;
    // leu neste aparelho (inclusive antes de 28/09): garante que o servidor também sabe
    if (jaLeu(login)) {
      void marcarAvisoLido('aviso-critico-v1');
      return;
    }
    let vivo = true;
    void lerAvisosLidos().then((lidos) => {
      if (!vivo) return;
      if (lidos?.includes('aviso-critico-v1')) {
        guardarLocal(login);
        // o tutorial espera o aviso: libera como se tivesse acabado de ler
        window.dispatchEvent(new Event('inovapay:aviso-lido'));
      } else setAberto(true);
    });
    return () => {
      vivo = false;
    };
  }, [login]);

  useEffect(() => {
    if (!aberto || falta <= 0) return;
    const t = window.setTimeout(() => setFalta((f) => f - 1), 1000);
    return () => window.clearTimeout(t);
  }, [aberto, falta]);

  if (!aberto || !login) return null;
  const entendi = () => {
    guardarLocal(login);
    void marcarAvisoLido('aviso-critico-v1');
    setAberto(false);
    // o tutorial de boas-vindas espera o aviso ser lido
    window.dispatchEvent(new Event('inovapay:aviso-lido'));
  };

  return (
    <div className="ac2-fundo" role="dialog" aria-modal="true" aria-labelledby="ac2-titulo">
      <div className="ac2-cartao">
        <div className="ac2-topo">
          <div id="ac2-titulo" className="ac2-titulo">
            Aviso crítico
          </div>
          <div className="ac2-sub">Leia até o fim — aparece só uma vez</div>
        </div>
        <section className="ac2-regra">
          <div className="ac2-selo">Extremamente proibido</div>
          <h2>Vender um produto e colocar o LOTE de outro</h2>
          <p>
            Não lance uma venda usando o lote/validade de um produto diferente do que foi vendido.
            Cada venda tem que ter o lote correto do produto correto.
          </p>
          <p className="ac2-pena">Quem fizer isso PERDE o mês inteiro de vitamina.</p>
        </section>
        <section className="ac2-regra">
          <div className="ac2-selo">Extremamente super proibido</div>
          <h2>Lançar venda pra Mais Brasil ou Formulativa no InovaPay</h2>
          <p>
            As vendas pra Mais Brasil e Formulativa caem no <b>CÓDIGO 30</b>. Não anote essas vendas
            aqui no InovaPay — nem de Paradão, nem de Pré-vencido, nem de Vitamina.
          </p>
          <p className="ac2-pena">Quem for pego TEM A VITAMINA DO MÊS CORTADA.</p>
        </section>
        <div className="ac2-assina">— Rede Inova Drogarias</div>
        <button type="button" className="ac2-botao" disabled={falta > 0} onClick={entendi}>
          {falta > 0 ? `Leia com atenção… ${String(falta)}s` : 'Li e entendi'}
        </button>
      </div>
    </div>
  );
}
